'use client';

import type { ReactNode } from 'react';
import { AttackerEditModalWrapper } from '../../HITL/wrappers/AttackerEditModalWrapper';
import type { EditModalProps } from '../../tool-config-types';

export const renderAttackerEditModal = (props: EditModalProps): ReactNode => (
  <AttackerEditModalWrapper
    isOpen={props.isOpen}
    onClose={props.onClose}
    onSubmit={props.onSubmit}
    toolName={props.toolName}
    extractedData={props.extractedData}
  />
);
